import React from 'react';
import '../styles/GuiaCard.css';

interface GuiaCardProps {
  onClose: () => void;
}

export const GuiaCard: React.FC<GuiaCardProps> = ({ onClose }) => {
  return (
    <div className="guia-overlay" onClick={onClose}>
      <div className="guia-card" onClick={(e) => e.stopPropagation()}>
        <div className="guia-header">
          <h2>📖 Guía de Carga de Facturas</h2>
          <button className="guia-close" onClick={onClose}>✕</button>
        </div>

        <div className="guia-content">
          <section className="guia-section">
            <h3>📤 Paso 1: Subir el PDF</h3>
            <ul>
              <li>Hacé click en "Seleccionar archivo PDF" o arrastrá el archivo directamente</li>
              <li>El archivo debe ser un PDF legible y no debe superar los 10MB</li>
              <li>Asegurate de que contenga todos los datos fiscales obligatorios</li>
            </ul>
          </section>

          <section className="guia-section">
            <h3>🤖 Paso 2: Procesamiento Automático</h3>
            <ul>
              <li>Nuestra IA procesará el PDF y extraerá automáticamente los datos</li>
              <li>El proceso puede tardar entre 5 y 30 segundos</li>
              <li>Verás el progreso en pantalla: Subiendo → Procesando → Extrayendo → Listo</li>
            </ul>
          </section>

          <section className="guia-section">
            <h3>✓ Paso 3: Verificar Datos</h3>
            <ul>
              <li>Revisá que todos los datos extraídos sean correctos</li>
              <li>Podés modificar cualquier campo si es necesario</li>
              <li>Los campos obligatorios son: Tipo, Letra, Punto de venta, Número, CUIT Emisor</li>
              <li>Si hacés cambios, podés usar "Deshacer cambios" para restaurar los datos originales</li>
            </ul>
          </section>

          <section className="guia-section">
            <h3>💾 Paso 4: Guardar</h3>
            <ul>
              <li>Una vez verificados los datos, hacé click en "Guardar cambios"</li>
              <li>Recibirás una confirmación cuando la factura se haya guardado correctamente</li>
              <li>Podrás cargar una nueva factura automáticamente</li>
            </ul>
          </section>

          <section className="guia-section">
            <h3>⚠️ Problemas Comunes</h3>
            <ul>
              <li><strong>PDF ilegible:</strong> Asegurate de que el PDF no sea una imagen escaneada de baja calidad</li>
              <li><strong>Datos incorrectos:</strong> La IA puede equivocarse, siempre revisá los datos antes de guardar</li>
              <li><strong>Error al subir:</strong> Verificá tu conexión a internet y que el archivo sea un PDF válido</li>
            </ul>
          </section>

          <section className="guia-section">
            <h3>💡 Consejos</h3>
            <ul>
              <li>Para mejores resultados, usá PDFs generados digitalmente en lugar de escaneos</li>
              <li>Verificá siempre que el CUIT tenga 11 dígitos</li>
              <li>El CAE debe tener exactamente 14 dígitos</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default GuiaCard;
